import React, { createContext, useState, useEffect } from "react";

export const InternetStatusContext = createContext();

const PING_URL = "https://quick-production-b60d.up.railway.app/api/health";

export const InternetStatusProvider = ({ children }) => {
  const [online, setOnline] = useState(navigator.onLine);
  const [slow, setSlow] = useState(false);
  const [checking, setChecking] = useState(false);

  const checkSpeed = async () => {
    setChecking(true);
    const start = Date.now();

    try {
      const res = await fetch(`${PING_URL}?t=${Date.now()}`, {
        method: "GET",
        cache: "no-store",
      });

      if (!res.ok) throw new Error("Network error");

      const latency = Date.now() - start;

      setOnline(true);
      setSlow(latency > 1500);
    } catch (err) {
      setOnline(false);
      setSlow(false);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    checkSpeed();

    const handleOnline = () => checkSpeed();

    const handleOffline = () => {
      setOnline(false);
      setSlow(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    const interval = setInterval(() => {
      if (!online) checkSpeed();
    }, 5000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, [online]);

  return (
    <InternetStatusContext.Provider value={{ online, slow, checking, checkSpeed }}>
      {children}
    </InternetStatusContext.Provider>
  );
};
